import React from "react";
import { motion } from "framer-motion";
import { Heart, Users, MapPin } from "lucide-react";
import Modal from "../../../components/common/Modal";
import VoterAvatars from "../../singlesInferno/components/VoterAvatars";

const GuideDetailModal = ({ open, selectedGuide, onClose, handleVote, votedGuides, showToast }) => {
  const headerContent = (
    <div>
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.4 }}
        className="tw-bg-gradient-to-r tw-from-gray-900 tw-to-gray-600 tw-bg-clip-text tw-text-2xl tw-font-bold tw-text-transparent"
      >
        {selectedGuide?.guide_name || "Guide"}
      </motion.h2>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="tw-mt-2 tw-flex tw-flex-col tw-space-y-1"
      >
        <span className="tw-text-sm tw-text-gray-500">
          Nominated by {selectedGuide?.author || "Anonymous"}
        </span>
        {selectedGuide?.trip_experience && (
          <div className="tw-flex tw-items-center tw-space-x-1">
            <MapPin className="tw-h-4 tw-w-4 tw-text-gray-400" />
            <span className="tw-text-sm tw-text-gray-500">{selectedGuide.trip_experience}</span>
          </div>
        )}
      </motion.div>
    </div>
  );

  return (
    <Modal open={open} onClose={onClose} headerContent={headerContent} maxHeight="80vh">
      {selectedGuide?.images && selectedGuide.images.length > 0 && (
        <div className="tw-mb-6 tw-grid tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-2">
          {selectedGuide.images.map((image, index) => (
            <div key={index} className="tw-h-64 tw-overflow-hidden tw-rounded-xl">
              <img
                src={image}
                alt={`${selectedGuide.guide_name} - Photo ${index + 1}`}
                className="tw-h-full tw-w-full tw-object-cover"
              />
            </div>
          ))}
        </div>
      )}

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.4 }}
        className="tw-mb-8 tw-pr-2"
      >
        <h3 className="tw-mb-2 tw-font-semibold tw-text-gray-800">
          Why this guide should come to Sofest:
        </h3>
        {selectedGuide?.description ? (
          <p className="tw-whitespace-pre-line tw-text-gray-600">{selectedGuide.description}</p>
        ) : (
          <p className="tw-italic tw-text-gray-400">No description provided</p>
        )}
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.4 }}
        className="tw-flex tw-flex-col tw-space-y-4"
      >
        <div className="tw-flex tw-items-center tw-justify-between">
          <div className="tw-flex tw-items-center tw-space-x-4">
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => {
                if (selectedGuide?.id) {
                  handleVote(selectedGuide?.id);
                } else {
                  showToast("Unable to vote at this time", "error");
                }
              }}
              className="tw-flex tw-items-center tw-space-x-2 tw-rounded-full tw-bg-rose-50 tw-px-4 tw-py-2 tw-transition-colors hover:tw-bg-rose-100"
            >
              <Heart
                className={`tw-h-5 tw-w-5 ${
                  selectedGuide?.id && votedGuides.has(selectedGuide.id)
                    ? "tw-fill-rose-500 tw-text-rose-500"
                    : "tw-text-rose-500"
                }`}
              />
              <span className="tw-font-medium tw-text-rose-500">
                {selectedGuide?.id && votedGuides.has(selectedGuide.id) ? "Voted" : "Vote"}
              </span>
            </motion.button>
            <p className="tw-text-gray-500">
              {selectedGuide?.votes || 0} {selectedGuide?.votes === 1 ? "vote" : "votes"}
            </p>
          </div>
        </div>

        {selectedGuide?.voters && selectedGuide.voters.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7 }}
            className="tw-rounded-xl tw-bg-gray-50 tw-p-4"
          >
            <div className="tw-mb-3 tw-flex tw-items-center tw-space-x-3">
              <Users className="tw-h-5 tw-w-5 tw-text-gray-500" />
              <span className="tw-font-medium tw-text-gray-700">Supporters</span>
            </div>
            <VoterAvatars voters={selectedGuide.voters} maxDisplay={8} />
            {selectedGuide.voters.length > 8 && (
              <p className="tw-mt-2 tw-text-sm tw-text-gray-500">
                +{selectedGuide.voters.length - 8} more supporters
              </p>
            )}
          </motion.div>
        )}
      </motion.div>
    </Modal>
  );
};

export default GuideDetailModal;
